import Block, { GalleryItems } from './block';
import getChildren from '../../utils/defaultChildren';

export default {
	component: Block,
	getChildren: record => record.content,
	rawComponent: GalleryItems
};
